import { useState, useEffect, useCallback } from 'react';
import io from 'socket.io-client';
import api from '@/services/api';

let socket;

export const useNotifications = (userId) => {
  const [notifications, setNotifications] = useState([]);
  const [totalPending, setTotalPending] = useState(0);
  const [filtroTipo, setFiltroTipo] = useState('todas');
  const [loading, setLoading] = useState(false);

  const loadNotifications = useCallback(async () => {
    if (!userId) return;
    setLoading(true);
    try {
      const res = await api.get(`/notificaciones/pendientes?tipo=${filtroTipo}`);
      setNotifications(res.data);
      setTotalPending(res.data.length);
    } catch (err) {
      console.error('Error cargando notificaciones:', err);
    } finally {
      setLoading(false);
    }
  }, [userId, filtroTipo]);

  // WebSocket en tiempo real
  useEffect(() => {
    if (!userId) return;
    if (!socket) {
      socket = io(import.meta.env.VITE_WS_URL || window.location.origin, {
        auth: { userId }
      });
      socket.on('new_notification', () => {
        loadNotifications();
      });
      socket.on('notifications_resolved', () => {
        loadNotifications();
      });
    }
    return () => {
      if (socket) {
        socket.disconnect();
        socket = undefined;
      }
    };
  }, [userId, loadNotifications]);

  // Polling cada 30 segundos (fallback)
  useEffect(() => {
    if (!userId) return;
    loadNotifications();
    const interval = setInterval(loadNotifications, 30000);
    return () => clearInterval(interval);
  }, [userId, loadNotifications]);

  const markAsAttended = async (id) => {
    await api.put(`/notificaciones/${id}/atender`);
    loadNotifications();
  };

  const markMultipleAttended = async (ids) => {
    await api.post('/notificaciones/batch/atender', { ids });
    loadNotifications();
  };

  const reload = () => loadNotifications();

  return {
    notifications,
    totalPending,
    loading,
    filtroTipo,
    setFiltroTipo,
    markAsAttended,
    markMultipleAttended,
    reload
  };
};